import { css } from '@emotion/css';

export const dropdownStyle = css`
	cursor: pointer;
	position: absolute;

	.dropdownItem {
		cursor: pointer;
		padding: 5px 10px;
		text-align: left;

		:hover {
			background-color: #f5f5f5;
		}
	}

	.deleteDropdownItem {
		color: #c40505bf;
	}
`;

export const columnDropdownStyle = css`
	width: 215px !important;
	text-align: left;
`;
